export default class Menu {
    DEFAULT_CONFIG = {
        selectors: {
            barLink: '[data-js-menu-bar-link]',
            closeButton: '[data-js-close-button]',
            controls: '[data-js-menu-controls]',
            controlBack: '[data-js-menu-control-back]',
            drawer: '[data-js-menu-drawer]',
            item: '[data-js-menu-item]',
            itemButton: '[data-js-menu-item-button]',
            subItem: '[data-js-menu-sub-item]',
            subItemButton: '[data-js-menu-sub-item-button]'
        },
        classNames: {
            menuModifiers: {
                car: 'menu--car',
                bicycle: 'menu--bicycle',
                motorcycle: 'menu--motorcycle',
                caramper: 'menu--caramper'
            },
            htmlActiveMenu: 'has-active-menu',
            menuButtonActive: 'menu-button--active',
            menuOpened: 'menu--opened',
            barLinkActive: 'menu-bar__link--active',
            itemActive: 'menu__item--active',
            subItemActive: 'menu__sub-item--active',
            siteHeaderContainer: 'site-header__container'
        },
        dataset: {
            barLink: 'jsMenuBarLink',
            item: 'jsMenuItem'
        }
    };

    constructor({ menuNode, menuBarNode, menuButtonNode }, config = {}) {
        if (!menuButtonNode || !menuBarNode || !menuNode) {
            return;
        }

        this.config = { ...this.DEFAULT_CONFIG, ...config };

        this.menuNode = menuNode;
        this.menuBarNode = menuBarNode;
        this.menuButtonNode = menuButtonNode;

        this.mouseOutTimeout = null;

        this.init();
    }

    init() {
        this.declareNodes();
        this.bindEventListeners();
    }

    declareNodes() {
        this.barLinkNodes = this.menuBarNode.querySelectorAll(this.config.selectors.barLink);
        this.closeButtonNodes = this.menuNode.querySelectorAll(this.config.selectors.closeButton);
        this.controlsNode = this.menuNode.querySelector(this.config.selectors.controls);
        this.controlBackNode = this.menuNode.querySelector(this.config.selectors.controlBack);
        this.drawerNode = this.menuNode.querySelector(this.config.selectors.drawer);
        this.itemNodes = this.menuNode.querySelectorAll(this.config.selectors.item);
        this.itemButtonNodes = this.menuNode.querySelectorAll(this.config.selectors.itemButton);
        this.subItemNodes = this.menuNode.querySelectorAll(this.config.selectors.subItem);
        this.subItemButtonNodes = this.menuNode.querySelectorAll(this.config.selectors.subItemButton);
    }

    bindEventListeners() {
        this.menuButtonNode.addEventListener('click', () => this.handleMenuButtonClick());
        this.controlBackNode.addEventListener('click', () => this.handleControlBackClick());
        this.drawerNode.addEventListener('mouseleave', e => this.handleDrawerMouseOut(e));

        this.closeButtonNodes.forEach(closeButtonNode => {
            closeButtonNode.addEventListener('click', () => this.handleCloseButtonClick());
        });

        this.barLinkNodes.forEach(barLinkNode => {
            barLinkNode.addEventListener('mouseenter', e => this.handleBarLinkClick(e));
            barLinkNode.addEventListener('mouseleave', e => this.handleDrawerMouseOut(e));
        });

        this.itemButtonNodes.forEach(itemButtonNode => {
            itemButtonNode.addEventListener('click', e => this.handleItemButtonClick(e));
        });

        this.subItemButtonNodes.forEach(subItemButtonNode => {
            subItemButtonNode.addEventListener('click', e => this.handleSubItemButtonClick(e));
        });
    }

    handleMenuButtonClick() {
        this.toggleMenu();
    }

    handleCloseButtonClick() {
        this.toggleMenu(false);
    }

    handleControlBackClick() {
        this.reset();
    }

    handleDrawerMouseOut(e) {
        if (!this.drawerNode.contains(e.relatedTarget)) {
            this.mouseOutTimeout = setTimeout(() => {
                this.toggleMenu(false);
            }, 150);
        }
    }

    handleBarLinkClick(e) {
        e.preventDefault();
        clearTimeout(this.mouseOutTimeout);
        const barLinkNode = e.target.closest(this.config.selectors.barLink);

        this.reset();
        this.toggleBarLink(barLinkNode, true);
    }

    handleItemButtonClick(e) {
        this.toggleItem(e.target.closest(this.config.selectors.item));
    }

    handleSubItemButtonClick(e) {
        this.toggleSubItem(e.target.closest(this.config.selectors.subItem));
    }

    toggleMenu(toggle = !this.isOpened()) {
        this.menuButtonNode.classList.toggle(this.config.classNames.menuButtonActive, toggle);
        this.menuNode.classList.toggle(this.config.classNames.menuOpened, toggle);
        document.documentElement.classList.toggle(this.config.classNames.htmlActiveMenu, toggle);

        if (!toggle) {
            this.reset();
        }
    }

    toggleBarLink(barLinkNode, toggle) {
        const mobilityType = barLinkNode.dataset[this.config.dataset.barLink];

        barLinkNode.classList.toggle(this.config.classNames.barLinkActive, toggle);

        this.toggleMobilityType(mobilityType, toggle);
        this.toggleItem(
            Array.from(this.itemNodes).find(itemNode => itemNode.dataset[this.config.dataset.item] === mobilityType),
            toggle
        );
        this.toggleMenu(toggle);
    }

    toggleItem(itemNode, toggle) {
        const mobilityType = itemNode.dataset[this.config.dataset.item];
        const firstSubItemNode = itemNode.querySelector(this.config.selectors.subItem);

        this.toggleSubItem(firstSubItemNode);

        itemNode.classList.toggle(this.config.classNames.itemActive, toggle);

        this.toggleMobilityType(mobilityType, toggle);
    }

    toggleSubItem(subItemNode, toggle) {
        subItemNode.classList.toggle(this.config.classNames.subItemActive, toggle);
    }

    toggleMobilityType(mobilityType, toggle) {
        this.menuNode.classList.remove(Object.keys(this.config.classNames.menuModifiers).join(''));
        this.menuNode.classList.toggle(this.config.classNames.menuModifiers[mobilityType], toggle);
        document.documentElement.classList.remove(Object.keys(this.config.classNames.menuModifiers).join(''));
        document.documentElement.classList.toggle(this.config.classNames.menuModifiers[mobilityType], toggle);
    }

    isOpened() {
        return this.menuNode.classList.contains(this.config.classNames.menuOpened);
    }

    reset() {
        this.barLinkNodes.forEach(barLinkNode => barLinkNode.classList.remove(this.config.classNames.barLinkActive));
        this.itemNodes.forEach(itemNode => this.toggleItem(itemNode, false));
        this.subItemNodes.forEach(subItemNode => this.toggleSubItem(subItemNode, false));
    }
}
